




















































import Vue from 'vue';

import { Paciente } from '../../../../back/src/entity/Paciente';
import { montaFlagsAarray } from '../../utils/functions';

export default Vue.extend({
  name: 'ThePacientesAvisosTabela',
  props: {
    paciente: {
      type: Object as () => Paciente,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    statusObservacoes(): number {
      return this.paciente.status_observacoes;
    },
    flags(): { sigla: string, descricao: string, color: string }[] {
      return montaFlagsAarray(this.paciente.gestacao_atual);
    },
  },
});
